var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { usePopper } from 'react-popper';
import { SACard } from '../card';
import { SAText } from '../text';
import { setHSLLighness } from '../utilities';
var PopoverRoot = styled.div.attrs(function (_a) {
    var background = _a.background, zIndex = _a.zIndex;
    return ({
        background: background,
        zIndex: zIndex,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var background = _a.background, zIndex = _a.zIndex;
    return "\n      background: " + background + ";\n      position: fixed;\n      top: 0;\n      left: 0;\n      margin: 0;\n      padding: 0;\n      width: 100%;\n      height: 100%;\n      z-index: " + zIndex + ";\n      pointer-events: none;\n      * {\n        pointer-events: auto;\n      }\n    ";
});
var ListMenu = styled.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  list-style: none;\n"], ["\n  list-style: none;\n"])));
var MenuItem = styled.li.attrs(function (_a) {
    var variant = _a.variant;
    return ({
        variant: variant,
    });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme, variant = _a.variant;
    var fontSize = variant === 'popover-menu-adjss' ? theme === null || theme === void 0 ? void 0 : theme.font.primary.size.smallTEMP : theme === null || theme === void 0 ? void 0 : theme.font.primary.size.medium;
    return "\n      padding-top: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + ";\n      padding-right: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + ";\n      padding-bottom: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.small) + ";\n      padding-left: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + ";\n\n      &:first-child {\n        padding-top: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + ";\n      }\n\n      &:last-child {\n        padding-bottom: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + ";\n      }\n\n      &:hover {\n        background-color: " + setHSLLighness(theme === null || theme === void 0 ? void 0 : theme.color.background.background, 98) + ";\n        cursor: pointer;\n      }\n\n      &:focus {\n        background-color: " + setHSLLighness(theme === null || theme === void 0 ? void 0 : theme.color.background.background, 98) + ";\n        outline: none;\n      }\n\n      span {\n        font-size: " + fontSize + ";\n        &:hover {\n          cursor: pointer;\n        }\n      }\n    ";
});
export function SAPopover(_a) {
    var background = _a.background, children = _a.children, data = _a.data, offset = _a.offset, onClose = _a.onClose, placement = _a.placement, referenceElement = _a.referenceElement, variant = _a.variant, zIndex = _a.zIndex;
    var _b = useState(null), popperElement = _b[0], setPopperElement = _b[1];
    var _c = useState(null), mouseEvent = _c[0], setMouseEvent = _c[1];
    var _d = useState(false), updateRef = _d[0], setUpdateRef = _d[1];
    var _e = useState(true), ignoreClick = _e[0], setIgnoreClick = _e[1];
    function getPlacement() {
        switch (placement) {
            case 'top-start':
                return 'bottom-start';
            case 'top':
                return 'bottom';
            case 'top-end':
                return 'bottom-end';
            case 'left':
                return 'right';
            case 'right':
                return 'left';
            case 'bottom-start':
                return 'top-start';
            case 'bottom-end':
                return 'top-end';
            case 'bottom':
            default:
                return 'top';
        }
    }
    var popoverPlacement = variant.includes('snackbar') ? getPlacement() : placement;
    var _f = usePopper(referenceElement, popperElement, {
        placement: popoverPlacement,
        modifiers: [
            {
                name: 'offset',
                options: { offset: offset },
            },
        ],
    }), styles = _f.styles, attributes = _f.attributes;
    function handleClick(event, index) {
        // forward the event and index to the callback function
        onClose(event, index);
    }
    function generateGetBoundingClientRect(x, y) {
        return function () { return ({
            width: 0,
            height: 0,
            top: y,
            right: x,
            bottom: y,
            left: x,
        }); };
    }
    function getX() {
        switch (placement) {
            case 'top-start':
            case 'left':
            case 'bottom-start':
                return 0;
            case 'top-end':
            case 'right':
            case 'bottom-end':
                return document.documentElement.clientWidth;
            case 'top':
            case 'bottom':
            default:
                return document.documentElement.clientWidth / 2;
        }
    }
    function getY() {
        switch (placement) {
            case 'top-start':
            case 'top':
            case 'top-end':
                return 0;
            case 'left':
            case 'right':
                return document.documentElement.clientHeight / 2;
            case 'bottom-start':
            case 'bottom':
            case 'bottom-end':
            default:
                return document.documentElement.clientHeight;
        }
    }
    useEffect(function () {
        function updateReference() {
            setUpdateRef(true);
        }
        if (variant === 'popover-snackbar') {
            window.addEventListener('resize', updateReference);
            window.addEventListener('scroll', updateReference);
        }
        return function () {
            window.removeEventListener('resize', updateReference);
            window.removeEventListener('scroll', updateReference);
        };
    }, []);
    useEffect(function () {
        if (variant === 'popover-snackbar') {
            if (referenceElement && updateRef) {
                var x = getX();
                var y = getY();
                // eslint-disable-next-line no-param-reassign
                referenceElement.getBoundingClientRect = generateGetBoundingClientRect(x, y);
            }
            setUpdateRef(false);
        }
    }, [updateRef]);
    useEffect(function () {
        // call callback function for clicks outside the referenceElement and popoverElement
        // when the popover is open.  Popover is open when referenceElement is not null.
        if (referenceElement && popperElement && mouseEvent) {
            // if element is a VirtualElement then it should have a getBoundingClientRect property
            if (Object.prototype.hasOwnProperty.call(referenceElement, 'getBoundingClientRect')) {
                // If the mouse click was outside of the popperElement and it isn't the initial
                // opening of the popover, then close the popover.
                if (!popperElement.contains(mouseEvent.target) && !ignoreClick) {
                    onClose(mouseEvent, null);
                    setMouseEvent(null);
                    // set to ignore first click again
                    setIgnoreClick(true);
                }
                else {
                    // don't ignore subsequent click, we want it to close on the next click if clicked
                    // outside of the popper.
                    setIgnoreClick(false);
                    return;
                }
            }
            if (referenceElement instanceof Element && referenceElement.contains(mouseEvent.target)) {
                return;
            }
            if (!(referenceElement instanceof Element)) {
                return;
            }
            if (popperElement.contains(mouseEvent.target)) {
                return;
            }
            onClose(mouseEvent, null);
            setMouseEvent(null);
        }
        if (referenceElement === null && !ignoreClick) {
            // set to ignore first click
            setIgnoreClick(true);
        }
    }, [referenceElement, popperElement, mouseEvent]);
    useEffect(function () {
        function handleDocumentClick(event) {
            // save our event so we can process it in the useEffect() above.
            if (!(variant === 'popover-menu-no-click')) {
                setMouseEvent(event);
            }
        }
        document.addEventListener('mousedown', handleDocumentClick);
        return function () {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, []);
    // eslint-disable-next-line consistent-return
    function getContent() {
        // eslint-disable-next-line default-case
        switch (variant) {
            case 'popover-minimal':
                return React.createElement(SACard, { variant: "minimal" }, children);
            case 'popover-minimal-nopadding':
                return (React.createElement(SACard, { variant: "minimal", removePadding: true }, children));
            case 'popover-custom':
            case 'popover-snackbar':
                return children;
            case 'popover-menu':
            case 'popover-menu-no-click':
                if (data) {
                    return (React.createElement(SACard, { variant: "minimal", removePadding: true },
                        React.createElement(ListMenu, null, data.map(function (item, index) {
                            return (React.createElement(MenuItem, { key: item, onClick: function (e) { return handleClick(e, index); }, variant: variant },
                                React.createElement(SAText, { type: "standard", text: item })));
                        }))));
                }
                return children;
            case 'popover-menu-adjss':
                if (data) {
                    return (React.createElement(SACard, { variant: "minimal", removePadding: true },
                        React.createElement(ListMenu, null, data.map(function (item, index) {
                            return (React.createElement(MenuItem, { key: item, onClick: function (e) { return handleClick(e, index); }, variant: variant },
                                React.createElement(SAText, { type: "standard", text: item })));
                        }))));
                }
                return children;
        }
    }
    var popoverContent = getContent();
    return (React.createElement(React.Fragment, null, referenceElement && (React.createElement(PopoverRoot, { background: background, zIndex: zIndex },
        React.createElement("div", __assign({ ref: setPopperElement, style: styles.popper }, attributes.popper), popoverContent)))));
}
SAPopover.defaultProps = {
    background: 'rgba(0, 0, 0, 0)',
    children: React.createElement(React.Fragment, null),
    data: null,
    offset: [0, 0],
    placement: 'bottom',
    zIndex: 1400,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=popover.component.js.map